import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class URLResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'url': "http://localhost:8080/file"
            },
            errors: []
        }
    }

    url() {
        return this.content().url
    }
}